import React, { useEffect, useState, useMemo } from "react";
import styles from "./checkout.module.css";
import {
    Box,
    RadioGroup,
    FormControlLabel,
    Radio,
    TextField,
    Button,
    Typography,
    FormControl,
} from "@mui/material";
import { Close, Edit, DeleteDataIcon } from "../../../Svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from 'formik';
import * as yup from "yup";
import axios from "axios";
import { Country, State, City } from "country-state-city";
import CouponPopup from "../../components/couponpopup/CouponPopup";
import Toastify from "../../../helper/Toastify";
import api from "../../../helper/Api";
import { toast } from "react-toastify";
import { setAllCarts } from "../../../redux/cartSlice";
import { getGoldRate, getActiveCountries } from "../../../redux/homeSlice";
import { getTermsAndCondition } from "../../../redux/productsSlice";
import CustomSeparator from "../../components/maincomps/breadcrumbs/Breadcrumbs";
import breadcrumbStyle from "../../components/maincomps/breadcrumbs/breadcrumbs.module.css"
import DeleteModal from "../../../Dashboard/components/deleteAddress/DeleteAddress";
import { Delete } from "@mui/icons-material";
import { deleteBillingAddress } from "../../../redux/userSlice";


const Checkout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { user } = useSelector((state) => state.user)
    const { applyCouponData } = useSelector((state) => state.coupons)
    const { goldRateData } = useSelector((state) => state.appearances);
    const { termsAndConditionData } = useSelector((state) => state.products);
    const { activeCountries } = useSelector((state) => state.appearances);
    // console.log('termsAndConditionData', termsAndConditionData);
    const token = localStorage.getItem("token");
    const [newAddress, setNewAddress] = useState(false)
    const [newShippingAddress, setNewShippingAddress] = useState(false)

    const [selectedShippingAddress, setSelectedShippingAddress] = useState("");
    const [hoveredCategory, setHoveredCategory] = useState(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [datas, setData] = useState([]);

    // console.log('location', location);

    const item = location?.state;
    const selectedValue = item?.selectedValue;
    const advancePayment = item?.advancePayment;
    const quantity = item?.quantity || 1;
    const product = item?.product || [];
    const orderType = item?.orderType;
    const grandTotalFromCart = item?.grandTotal || 0;
    const priceFromCart = item?.price || 0;

    useEffect(() => {
        dispatch(getGoldRate())
    }, [dispatch]);

    useEffect(() => {
        const getAllActiveCountries = async () => {
            try {
                await dispatch(getActiveCountries());
            } catch (error) {
                console.log(error);
            }
        };
        getAllActiveCountries();
    }, [dispatch]);


    const prod = product?.map((i) => ({
        productId: i?.product?._id,
        productName: i?.product?.productName,
        quantity: i?.quantity,
        totalPrice: i?.totalPrice,
        sellingPrice: i?.sellingPrice,
        discount: i?.totalPrice - i?.sellingPrice,
        orderType: i.product?.gold?.orderType,
        totalWeight: i?.product?.pricing?.totalWeight?.value,
        stoneCharges: i?.product?.pricing?.stoneCharges?.value,
        makingCharges: i?.product?.pricing?.makingCharges?.value,
        gst: i?.product?.pricing?.gst?.value,
        polkiCarat: i?.product?.pricing?.polkiCarat?.value,
        polkiPerCarat: i?.product?.pricing?.polkiPerCarat?.value,
        polkiCost: i?.product?.pricing?.polkiCost?.value,
        diamondCarat: i?.product?.pricing?.diamondCarat?.value,
        diamondPerCarat: i?.product?.pricing?.diamondPerCarat?.value,
        diamondCost: i?.product?.pricing?.diamondCost?.value,
        goldRate: i?.product?.pricing?.goldRate?.value,
        goldWeight: i?.product?.pricing?.goldWeight?.value,
        goldType: i?.product?.gold?.type,
        adPaymentAmount: i?.adPaymentAmount || 0,
        selectedPaymentType: i?.selectedPaymentType || '',
        extraWeight: 0,
        pendingAmount: i?.adPaymentAmount || 0
    }));

    // const discountValue = applyCouponData?.discount || 0
    const appliedCouponPrice = selectedValue === 'Ad Paid' ? advancePayment : item?.state?.sellingPrice

    const grandTotal = grandTotalFromCart !== 0 ? grandTotalFromCart : item?.state?.sellingPrice;


    const schema = yup.object().shape({
        panImage: yup.string().required("PAN Image is required"),
        panNumber: yup
            .string()
            .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN number")
            .required("PAN number is required"),
        // termsAndCondition: yup
        //   .boolean()
        //   .oneOf([true], "Please accept the terms and conditions"),
        billingAddress: yup.object().shape({
            firstName: yup.string().required("First name is required"),
            lastName: yup.string().required("Last name is required"),
            country: yup.string().required("Country is required"),
            streetAddress: yup.string().required("Address Line 1 is required"),
            unit: yup.string(),
            email: yup.string().email('Invalid email format').required('Email is required'),
            city: yup.string().required("City is required"),
            state: yup.string().required("State is required"),
            pincode: yup
                .string()
                .matches(/^\d{6}$/, "Pincode must be 6 digits")
                .required("Pincode is required"),
            phone: yup
                .string()
                .matches(/^\d{10}$/, "Invalid phone number")
                .required("Phone number is required"),
        }),
        shippingAddress: yup.object().shape({
            firstName: yup.string().required("First name is required"),
            lastName: yup.string().required("Last name is required"),
            country: yup.string().required("Country is required"),
            streetAddress: yup.string().required("Address Line 1 is required"),
            unit: yup.string(),
            email: yup.string().email('Invalid email format').required('Email is required'),
            city: yup.string().required("City is required"),
            state: yup.string().required("State is required"),
            pincode: yup
                .string()
                .matches(/^\d{6}$/, "Pincode must be 6 digits")
                .required("Pincode is required"),
            phone: yup
                .string()
                .matches(/^\d{10}$/, "Invalid phone number")
                .required("Phone number is required"),
        }),
        // saveBillingAddress: yup.boolean(), // Optional
    });

    const {
        errors,
        values,
        touched,
        handleChange,
        setFieldValue,
        setValues,
        handleSubmit,

    } = useFormik({
        initialValues: {
            products: prod,
            orderType: orderType ? orderType : item?.state?.product?.gold?.orderType,
            panImage: "",
            panNumber: "",
            gstIN: "",
            companyName: "",
            billingAddress: {
                firstName: "",
                lastName: "",
                country: "",
                streetAddress: "",
                unit: "",
                city: "",
                state: "",
                pincode: 0,
                phone: "",
                email: "",
                landmark: ""
            },
            saveBillingAddress: false,
            shippingAddress: {
                firstName: "",
                lastName: "",
                country: "",
                streetAddress: "",
                unit: "",
                city: "",
                state: "",
                pincode: 0,
                phone: "",
                email: "",
                landmark: ""
            },
            payment: {
                status: selectedValue ? selectedValue : 'Fully Paid',
                method: ""
            },
            // couponCode: applyCouponData?.couponCode,
            discount: item?.state?.mrpdiscount,
            total: item?.state?.totalPrice,
            // subTotal: grandTotal,
            shippingRate: 0,
            // gst: 0,
            grandTotal: item?.state?.sellingPrice,
            paidAmount: grandTotalFromCart !== 0 ? grandTotalFromCart : appliedCouponPrice,
            extraWeight: 0,
            advancePaid: selectedValue === 'Ad Paid' ? advancePayment : 0,
            pendingAmount: selectedValue === 'Ad Paid' ? advancePayment : 0,
            goldRate18k: goldRateData?.k18,
            goldRate22k: goldRateData?.k22,
            termsAndCondition: ''
        },
        validationSchema: schema,
        onSubmit: async (values) => {
            console.log("Form submitted", values);
            proceedTOPay(values)
        }

    });

    const activeCountryNames = useMemo(() => {
        return activeCountries?.data?.map(country => country.name) || [];
    }, [activeCountries]);

    const countries = useMemo(() => {
        return Country.getAllCountries()
            .filter(country => activeCountryNames.includes(country.name))
            .map(country => ({
                label: country.name,
                value: country.isoCode,
                fullName: country.name,
            }));
    }, [activeCountryNames]);

    useEffect(() => {
        if (activeCountryNames.length > 0 && values.billingAddress.country && !activeCountryNames.includes(values.billingAddress.country)) {
            setFieldValue("billingAddress.country", "");
            setFieldValue("billingAddress.state", "");
            setFieldValue("billingAddress.city", "");
        }
    }, [activeCountryNames, values.billingAddress.country, setFieldValue]);


    const billingStates = useMemo(() => {
        if (!values.billingAddress.country) return [];
        const countryObj = Country.getAllCountries().find(c => c.name === values.billingAddress.country);
        return State.getStatesOfCountry(countryObj?.isoCode).map(state => ({
            label: state.name,
            value: state.isoCode,
        }));
    }, [values.billingAddress.country]);

    const billingCities = useMemo(() => {
        if (!values.billingAddress.state || !values.billingAddress.country) return [];
        const countryObj = Country.getAllCountries().find(c => c.name === values.billingAddress.country);
        const stateObj = State.getStatesOfCountry(countryObj?.isoCode).find(s => s.name === values.billingAddress.state);
        return City.getCitiesOfState(countryObj?.isoCode, stateObj?.isoCode).map(city => ({
            label: city.name,
            value: city.name,
        }));
    }, [values.billingAddress.country, values.billingAddress.state]);

    const shippingStates = useMemo(() => {
        if (!values.shippingAddress.country) return [];
        const countryObj = Country.getAllCountries().find(c => c.name === values.shippingAddress.country);
        return State.getStatesOfCountry(countryObj?.isoCode).map(state => ({
            label: state.name,
            value: state.isoCode,
        }));
    }, [values.shippingAddress.country]);

    const shippingCities = useMemo(() => {
        if (!values.shippingAddress.state || !values.shippingAddress.country) return [];
        const countryObj = Country.getAllCountries().find(c => c.name === values.shippingAddress.country);
        const stateObj = State.getStatesOfCountry(countryObj?.isoCode).find(s => s.name === values.shippingAddress.state);
        return City.getCitiesOfState(countryObj?.isoCode, stateObj?.isoCode).map(city => ({
            label: city.name,
            value: city.name,
        }));
    }, [values.shippingAddress.country, values.shippingAddress.state]);

    const proceedTOPay = async () => {
        if (values.payment.method === "RAZORPAY") {
            await handleRazorpayPayment();
        } else if (values.payment.method === "HDFC") {
            await handleHdfcPayment();
        }
    }

    const removePanCardImage = () => {
        setFieldValue('panImage', '');
    }

    const handlePanCardImage = async (e, attribute, repo) => {

        const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];
        try {
            if (file) {

                const body = {
                    key: `${Date.now()}_${file.name}`,
                    fileName: file.name,
                }

                const { data, status } = await api.getPutSignedUrl(body);
                // console.log(data);

                if (status === 200) {
                    await axios.put(data.data?.preSigned, file, {
                        headers: {
                            "Content-Type": file.type
                        }
                    })

                    setFieldValue('panImage', data?.data?.url)
                }
            }
        } catch (err) {
            console.log(err);
            Toastify.error("Please login to your account")
        }
    };

    // addresses
    const handleBillingCountryChange = (e) => {
        const countryCode = e.target.value;
        const selectedCountry = countries.find((c) => c.value === countryCode);
        setFieldValue("billingAddress.country", selectedCountry?.fullName || ""); // Store country name
        setFieldValue("billingAddress.state", ""); // Reset state
        setFieldValue("billingAddress.city", "");  // Reset city
    };

    const handleBillingStateChange = (e) => {
        const stateCode = e.target.value;
        const selectedState = billingStates.find((s) => s.value === stateCode);
        setFieldValue("billingAddress.state", selectedState?.label || ""); // Store state name
        setFieldValue("billingAddress.city", ""); // Reset city
    };

    const handleBillingCityChange = (e) => {
        const cityCode = e.target.value;
        const selectedCity = billingCities.find(c => c.value === cityCode);
        setFieldValue("billingAddress.city", selectedCity?.label || "");
    };

    const handleShippingCountryChange = (e) => {
        const countryCode = e.target.value;
        const selectedCountry = countries.find((c) => c.value === countryCode);
        setFieldValue("shippingAddress.country", selectedCountry?.fullName || ""); // Store country name
        setFieldValue("shippingAddress.state", ""); // Reset state
        setFieldValue("shippingAddress.city", "");  // Reset city
    };

    const handleShippingStateChange = (e) => {
        const stateCode = e.target.value;
        const selectedState = shippingStates.find((s) => s.value === stateCode);
        setFieldValue("shippingAddress.state", selectedState?.label || ""); // Store state name
        setFieldValue("shippingAddress.city", ""); // Reset city
    };

    const handleShippingCityChange = (e) => {
        const cityCode = e.target.value;
        const selectedCity = shippingCities.find(c => c.value === cityCode);
        setFieldValue("shippingAddress.city", selectedCity?.label || "");
    };


    const handleSaveBillingAddress = (e) => {
        setFieldValue('saveBillingAddress', e.target.checked);
    };
    const handleSaveBillingAddresses = (selectedAddress) => {
        setValues((prevValues) => ({
            ...prevValues,
            billingAddress: selectedAddress,
            saveBillingAddress: true
        }));
    };
    const handleSaveShippingAddresses = (selectedAddress) => {
        setValues((prevValues) => ({
            ...prevValues,
            shippingAddress: selectedAddress,
        }));
    };

    const handleEditAddress = (selectedAddress) => {
        setValues((prevValues) => ({
            ...prevValues,
            billingAddress: selectedAddress
        }));
        setNewAddress(true); // Open the billing address form for editing
    };
    const handleEditShippingAddress = (selectedAddress) => {
        setValues((prevValues) => ({
            ...prevValues,
            shippingAddress: selectedAddress
        }));
        setNewShippingAddress(true); // Open the billing address form for editing
    };


    const handleChangeAddress = (event) => {
        const selectedOption = event.target.value;
        setSelectedShippingAddress(selectedOption);

        if (selectedOption === "Same as Billing address") {
            // Copy billingAddress to shippingAddress
            setFieldValue("shippingAddress", { ...values.billingAddress });
        } else {
            // Reset shippingAddress fields if the user selects a different address
            setFieldValue("shippingAddress", {
                firstName: "",
                lastName: "",
                country: "",
                streetAddress: "",
                unit: "",
                city: "",
                state: "",
                pincode: 0,
                phone: "",
                email: "",
                landmark: ""
            });
        }
    };

    const handleRazorpayPayment = async () => {
        try {
            // Step 1: Check if the user is logged in
            if (!token) {
                Toastify.error("Please login to your account");
                return;
            }

            // Step 2: Get the billing details (from Formik values or selected address)
            const billingDetails = values.billingAddress.firstName && values.billingAddress.lastName && values.billingAddress.pincode
                ? {
                    billing_customer_name: values.billingAddress.firstName,
                    billing_last_name: values.billingAddress.lastName,
                    billing_address: `${values.billingAddress.streetAddress}, ${values.billingAddress.unit}`,
                    billing_city: values.billingAddress.city,
                    billing_pincode: values.billingAddress.pincode,
                    billing_state: values.billingAddress.state,
                    billing_country: values.billingAddress.country,
                    billing_phone: values.billingAddress.phone,
                }
                : selectedShippingAddress
                    ? {
                        billing_customer_name: selectedShippingAddress.firstName,
                        billing_last_name: selectedShippingAddress.lastName,
                        billing_address: selectedShippingAddress.streetAddress,
                        billing_city: selectedShippingAddress.city,
                        billing_pincode: selectedShippingAddress.pincode,
                        billing_state: selectedShippingAddress.state,
                        billing_country: selectedShippingAddress.country,
                        billing_phone: selectedShippingAddress.phone,
                    }
                    : null;

            if (!billingDetails) {
                toast.error("No valid billing address available.");
                return;
            }

            // Step 3: Check serviceability before proceeding with payment
            const serviceabilityResponse = await api.pinCodeValidation({
                pincode: values.billingAddress.pincode.toString(),
            });

            if (serviceabilityResponse.status === false) {
                Toastify.error("Delivery is not available for this address. Please enter a different address.");
                return;
            }

            // Step 4: Proceed with Razorpay payment initiation
            const paymentResponse = await api.paymentStepOne({
                grandTotal: grandTotalFromCart !== 0 ? grandTotalFromCart : appliedCouponPrice,
                currency: 'INR',
            });

            const { order } = paymentResponse.data.data;

            // Step 5: Initialize Razorpay payment options
            const options = {
                key: "rzp_live_0sPo86UGWBLY0z",
                amount: order.amount,
                currency: 'INR',
                order_id: order.id,
                handler: async function (response) {
                    const { razorpay_payment_id, razorpay_order_id, razorpay_signature } = response;
                    console.log('response', response);
                    try {
                        // Step 6: Place the order after successful payment
                        const placeResp = await api.placeOrder({
                            razorpay_payment_id,
                            razorpay_order_id,
                            razorpay_signature,
                            ...values,
                            payment_method: "Prepaid",
                            currency: "INR",

                            ...billingDetails,
                        });

                        // Step 7: Navigate to Thank You page and clear cart
                        if (placeResp?.data?.success) {
                            // ✅ success path
                            const { message, order } = placeResp.data?.data;
                            dispatch(setAllCarts([]));
                            navigate(`/thankyouPopup?order_id=${order.hdfc_order_id}`);
                        } else {
                            // 🛑 success: false
                            const reason = placeResp.data?.data?.message || 'Unknown error';
                            navigate(`/paymentFailed?reason=${encodeURIComponent(reason)}`);
                        }

                        dispatch(setAllCarts([]));
                    } catch (error) {
                        console.error("Order placement error:", error);
                    }
                },
            };

            // Step 8: Open Razorpay payment gateway
            const razorpay = new window.Razorpay(options);
            razorpay.on("payment.failed", () => {
                navigate(`/paymentFailed`);
            });

            razorpay.open();
        } catch (error) {
            navigate(`/paymentFailed`);
            console.error("Payment error:", error);
        }
    };

    const handleHdfcPayment = async () => {
        try {
            if (!token) {
                Toastify.error("Please login to your account");
                return;
            }

            const billingDetails = values.billingAddress.firstName && values.billingAddress.lastName && values.billingAddress.pincode
                ? {
                    billing_customer_name: values.billingAddress.firstName,
                    billing_last_name: values.billingAddress.lastName,
                    billing_address: `${values.billingAddress.streetAddress}, ${values.billingAddress.unit}`,
                    billing_city: values.billingAddress.city,
                    billing_pincode: values.billingAddress.pincode,
                    billing_state: values.billingAddress.state,
                    billing_country: values.billingAddress.country,
                    billing_phone: values.billingAddress.phone,
                }
                : selectedShippingAddress
                    ? {
                        billing_customer_name: selectedShippingAddress.firstName,
                        billing_last_name: selectedShippingAddress.lastName,
                        billing_address: selectedShippingAddress.streetAddress,
                        billing_city: selectedShippingAddress.city,
                        billing_pincode: selectedShippingAddress.pincode,
                        billing_state: selectedShippingAddress.state,
                        billing_country: selectedShippingAddress.country,
                        billing_phone: selectedShippingAddress.phone,
                    }
                    : null;

            if (!billingDetails) {
                toast.error("No valid billing address available.");
                return;
            }

            const serviceabilityResponse = await api.pinCodeValidation({
                pincode: values.billingAddress.pincode.toString(),
            });

            if (serviceabilityResponse.status === false) {
                Toastify.error("Delivery is not available for this address. Please enter a different address.");
                return;
            }

            const paymentResponse = await api.paymentStepOneHdfc({
                amount: grandTotalFromCart !== 0 ? grandTotalFromCart : appliedCouponPrice,
            });

            const { paymentUrl, order } = paymentResponse.data;
            console.log('order', order);

            if (!paymentUrl) {
                Toastify.error("Unable to initiate payment.");
                return;
            }

            await api.saveOrderDraft({
                ...values,
                order_id: order?.order_id,
                grandTotal: item.state.sellingPrice,
                paidAmount: order?.sdk_payload?.payload?.amount,
                payment_method: "HDFC",
                currency: "INR",
                ...billingDetails,
            });

            console.log("redirecting to paymentUrl:", paymentUrl);
            window.location.href = paymentUrl;

        } catch (error) {
            console.error("HDFC Payment error:", error);
            Toastify.error("Something went wrong. Please try again.");
        }
    };

    const deletedData = (value) => {
        dispatch(deleteBillingAddress(value));
    };

    //Delete User
    const openDeleteModal = (data) => {
        setData(data);
        setIsDeleteModalOpen(true);
    };
    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
    };
    React.useEffect(() => {
        dispatch(getTermsAndCondition())
    }, [dispatch])
    // console.log('values================', values);

    const handleCheckoutClick = async () => {
        const hasSavedAddresses = user?.shippingAddress?.length > 0;
        const isShippingAddressEmpty =
            !values.shippingAddress.firstName || !values.shippingAddress.lastName || !values.shippingAddress.country ||
            !values.shippingAddress.streetAddress || !values.shippingAddress.email || !values.shippingAddress.city ||
            !values.shippingAddress.state || !values.shippingAddress.pincode || !values.shippingAddress.phone;

        if (hasSavedAddresses && isShippingAddressEmpty) {
            Toastify.error("Please select a shipping address!");
            return;
        }
        if (!hasSavedAddresses && !selectedShippingAddress) {
            Toastify.error("Fill in the shipping address form below!");
            return;
        }

        handleSubmit();
    };

    return (
        <>
            <div className={breadcrumbStyle.breadcrumbStyle}>
                <CustomSeparator home="Home" type="Checkout" />
            </div>
            {/* <form onSubmit={handleSubmit}> */}
            <div className={styles.chekoutContainer}>

                <div className={styles.chekoutForm}>
                    <div className={styles.chekoutCustminfo}>
                        <form className={styles.profileform} /* onSubmit={handleSubmit} */>

                            <h2>Billing Details</h2>
                            <p>Note: Pan card details are needed as per the company policy of payment more than<span>RS. 2,00,000</span></p>
                            <div className={styles.profilerow}>
                                <div className={styles.profileformGroup1} style={{ borderRight: "none", borderRadius: '5px 0px 0px 5px !important' }}>

                                    <label>Pan card*</label>
                                    <div className={styles.profileformGroup1} style={{ flexDirection: "row", borderRight: "none", borderRadius: '5px 0px 0px 5px !important' }}>

                                        <div className={styles.imageUpload1}>
                                            {values?.panImage?.length > 0 ? (
                                                <div style={{ padding: 10, alignItems: 'center', display: 'flex', justifyContent: 'center', width: '100%', position: "relative" }}>
                                                    <img
                                                        src={values.panImage}
                                                        alt="Selected"
                                                        style={{ maxWidth: '100%', marginTop: '0px', width: 200, height: 100, objectFit: 'contain' }}
                                                    />
                                                    <div style={{ position: "absolute", top: 10, right: 10, cursor: "pointer" }} onClick={removePanCardImage}>
                                                        <Delete />
                                                    </div>
                                                    {/* <button onClick={handleUpload}>Upload</button> */}
                                                </div>
                                            ) : (
                                                <div className={styles.imageDisplay}>
                                                    <div className={styles.uploadText}>Upload Pan card image</div>
                                                    <div className={styles.imageView}>

                                                        <div className={styles.buttonText} style={{ padding: '7px', background: "#F0F1F3", borderRadius: 8 }}>
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                id="featuredFile"
                                                                style={{ display: 'none' }}
                                                                onChange={handlePanCardImage}
                                                            />
                                                            <label htmlFor="featuredFile" style={{ fontSize: 14, fontWeight: 700, fontFamily: 'karla' }}>
                                                                Add Image
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>


                                        {/* <button style={{ width: "50%", background: "#F0F1F3" }} className={styles.buttonText}>Upload Image</button> */}
                                    </div>
                                    {
                                        errors.panImage && touched.panImage && <p style={{ color: "red", fontSize: "12px" }}>{errors.panImage}</p>
                                    }
                                    {/* <div className={styles.formatText}>Image can be jpg, png format , less than 10 MB</div> */}
                                </div>

                                <div className={styles.profileformGroup}>
                                    <label>Pan Card Number*</label>
                                    <input
                                        type="text"
                                        name="panNumber"
                                        value={values.panNumber}
                                        onChange={handleChange}
                                        placeholder="Pan card number"
                                        required
                                    />
                                    {
                                        errors.panNumber && touched.panNumber && <p style={{ color: "red", fontSize: "12px" }}>{errors.panNumber}</p>
                                    }
                                </div>
                            </div>
                            <div className={styles.profilerow}>
                                <div className={styles.profileformGroup}>
                                    <label>GSTIN</label>
                                    <input
                                        type="text"
                                        name="gstIN"
                                        value={values.gstIN}
                                        onChange={handleChange}
                                        placeholder="Enter"
                                        required
                                    />

                                </div>
                                <div className={styles.profileformGroup}>
                                    <label>Company</label>
                                    <input
                                        type="text"
                                        name="companyName"
                                        value={values.companyName}
                                        onChange={handleChange}
                                        placeholder="Enter"
                                        required
                                    />

                                </div>
                            </div>
                            {/*  Add New Address */}
                            <h2>Billing Address</h2>
                            {user?.billingAddress?.length > 0 ? (
                                <div className={styles.addressSection}>
                                    <div className={styles.displayFlex} >
                                        {user?.billingAddress?.map((item) => (
                                            <div className={styles.address} >
                                                <div className={styles.displayFlex2}>
                                                    <input
                                                        type="radio"
                                                        name="saveBillingAddress"
                                                        checked={values.billingAddress.streetAddress === item.streetAddress}
                                                        onChange={() => handleSaveBillingAddresses(item)}
                                                    />
                                                    <div>
                                                        <p className={styles.addressNameText}>{item?.firstName}{" "}{item?.lastName}</p>
                                                        <div>
                                                            <p className={styles.addressText}>{item?.streetAddress} {item?.unit} {item?.city},
                                                                <br />
                                                                {item?.state} {item?.pinCode} {item?.country}</p>
                                                            <p className={styles.addressText}>(+91) {item?.phone}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={styles.addressIcons}>
                                                    <div style={{ cursor: 'pointer' }} onClick={() => handleEditAddress(item)}>
                                                        <Edit />
                                                    </div>
                                                    <div style={{ cursor: 'pointer' }} onClick={() => openDeleteModal(item?._id)}>
                                                        <Delete />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className={styles.addressDivider} onClick={() => setNewAddress(!newAddress)}>
                                        <button className={styles.addNewAddress}>
                                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M24 12.5C24 19.1274 18.6274 24.5 12 24.5C5.37258 24.5 0 19.1274 0 12.5C0 5.87258 5.37258 0.5 12 0.5C18.6274 0.5 24 5.87258 24 12.5ZM12 18.5C11.4477 18.5 11 18.0523 11 17.5V13.5H7C6.44772 13.5 6 13.0523 6 12.5C6 11.9477 6.44772 11.5 7 11.5H11V7.5C11 6.94771 11.4477 6.5 12 6.5C12.5523 6.5 13 6.94771 13 7.5V11.5H17C17.5523 11.5 18 11.9477 18 12.5C18 13.0523 17.5523 13.5 17 13.5H13V17.5C13 18.0523 12.5523 18.5 12 18.5Z" fill="#FE671F" />
                                            </svg>
                                        </button>
                                        <span>Add New Address</span>
                                    </div>
                                    {newAddress && (
                                        <>

                                            <div className={styles.profilerow}>
                                                <div className={styles.profileformGroup}>
                                                    <label>First Name*</label>
                                                    <input
                                                        type="text"
                                                        name="billingAddress.firstName"
                                                        value={values.billingAddress.firstName}
                                                        onChange={handleChange}
                                                        placeholder="First name"
                                                        required
                                                    />
                                                    {
                                                        errors?.billingAddress?.firstName && touched?.billingAddress?.firstName && <p style={{ color: "red", fontSize: "12px" }}>{errors?.billingAddress?.firstName}</p>
                                                    }
                                                </div>

                                                <div className={styles.profileformGroup}>
                                                    <label>Last Name*</label>
                                                    <input
                                                        type="text"
                                                        name="billingAddress.lastName"
                                                        value={values.billingAddress.lastName}
                                                        onChange={handleChange}
                                                        placeholder="Last name"
                                                        required
                                                    />
                                                    {
                                                        errors.billingAddress?.lastName && touched.billingAddress?.lastName && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.lastName}</p>
                                                    }
                                                </div>
                                            </div>
                                            <div className={styles.profilerow}>
                                                <div className={styles.profileformGroup}>
                                                    <label>Phone*</label>
                                                    <input
                                                        type="tel"
                                                        name="billingAddress.phone"
                                                        value={values.billingAddress.phone}
                                                        onChange={handleChange}
                                                        placeholder="Phone"
                                                        required
                                                    />
                                                    {
                                                        errors.billingAddress?.phone && touched.billingAddress?.phone && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.phone}</p>
                                                    }
                                                </div>

                                                <div className={styles.profileformGroup}>
                                                    <label>Email*</label>
                                                    <input
                                                        type="text"
                                                        name="billingAddress.email"
                                                        value={values.billingAddress.email}
                                                        onChange={handleChange}
                                                        placeholder="Email"
                                                        required
                                                    />
                                                    {
                                                        errors.billingAddress?.email && touched.billingAddress?.email && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.email}</p>
                                                    }
                                                </div>


                                            </div>
                                            <div className={styles.profilerow}>
                                                <div className={styles.profileformGroup}>
                                                    <label>Address Line 1 *</label>
                                                    <input
                                                        type="text"
                                                        name="billingAddress.streetAddress"
                                                        value={values.billingAddress.streetAddress}
                                                        onChange={handleChange}
                                                        placeholder="House/Flat No., Building Name"
                                                    />
                                                    {
                                                        errors.billingAddress?.streetAddress && touched.billingAddress?.streetAddress && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.streetAddress}</p>
                                                    }
                                                </div>
                                                <div className={styles.profileformGroup}>
                                                    <label>Address Line 2</label>
                                                    <input
                                                        type="text"
                                                        name="billingAddress.unit"
                                                        value={values.billingAddress.unit}
                                                        onChange={handleChange}
                                                        placeholder="Street Name, Locality"
                                                    />
                                                </div>
                                            </div>
                                            <div className={styles.profilerow}>
                                                <div className={styles.profileformGroup}>
                                                    <label>Landmark</label>
                                                    <input
                                                        type="text"
                                                        name="billingAddress.landmark"
                                                        value={values.billingAddress?.landmark}
                                                        onChange={handleChange}
                                                        placeholder="Landmark"
                                                    />
                                                </div>
                                                <div className={styles.profileformGroup}>
                                                    <label>Country*</label>
                                                    <select
                                                        name="billingAddress.country"
                                                        value={countries.find(c => c.label === values.billingAddress.country)?.value || ""}
                                                        onChange={handleBillingCountryChange}
                                                        className={styles.selectField}
                                                    >
                                                        <option value="">Select</option>
                                                        {countries.length > 0 ? (
                                                            countries.map((country) => (
                                                                <option key={country.value} value={country.value}>
                                                                    {country.label}
                                                                </option>
                                                            ))
                                                        ) : (
                                                            <option disabled>Loading countries...</option>
                                                        )}
                                                    </select>
                                                    {
                                                        errors.billingAddress?.country && touched.billingAddress?.country && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.country}</p>
                                                    }
                                                </div>

                                            </div>
                                            <div className={styles.profilerow}>
                                                <div className={styles.profileformGroup}>
                                                    <label>State*</label>
                                                    <select
                                                        name="billingAddress.state"
                                                        value={billingStates.find(c => c.label === values.billingAddress.state)?.value || ""}
                                                        onChange={handleBillingStateChange}
                                                        className={styles.selectField}
                                                    >
                                                        <option value="">Select State</option>
                                                        {billingStates?.map((state) => (
                                                            <option key={state.value} value={state.value}>
                                                                {state.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {
                                                        errors.billingAddress?.state && touched.billingAddress?.state && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.state}</p>
                                                    }
                                                </div>

                                                <div className={styles.profileformGroup}>
                                                    <label>Zip*</label>
                                                    <input
                                                        type="text"
                                                        name="billingAddress.pincode"
                                                        value={values.billingAddress.pincode}
                                                        onChange={handleChange}
                                                        placeholder="Pincode"
                                                        required
                                                    />
                                                    {
                                                        errors.billingAddress?.pincode && touched.billingAddress?.pincode && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.pincode}</p>
                                                    }
                                                </div>
                                            </div>
                                            <div className={styles.loginFormRow2}>
                                                <div className={styles.profileformGroup}>
                                                    <label>City*</label>
                                                    <select
                                                        name="billingAddress.city"
                                                        value={billingCities.find(c => c.label === values.billingAddress.city)?.value || ""}
                                                        onChange={handleBillingCityChange}
                                                        className={styles.selectField}
                                                    >
                                                        <option value="">Select City</option>
                                                        {billingCities?.map((city) => (
                                                            <option key={city.value} value={city.value}>
                                                                {city.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {
                                                        errors.billingAddress?.city && touched.billingAddress?.city && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.city}</p>
                                                    }
                                                </div>

                                            </div>

                                            <div className={styles.checkboxGroup}>
                                                <input
                                                    type="checkbox"
                                                    name="saveBillingAddress"
                                                    checked={values.saveBillingAddress}
                                                    onChange={handleSaveBillingAddress}
                                                />
                                                <label>Save my information for a faster checkout</label>

                                            </div>
                                        </>
                                    )}
                                </div>
                            ) : (
                                <>

                                    <div className={styles.profilerow}>
                                        <div className={styles.profileformGroup}>
                                            <label>First Name*</label>
                                            <input
                                                type="text"
                                                name="billingAddress.firstName"
                                                value={values.billingAddress.firstName}
                                                onChange={handleChange}
                                                placeholder="First name"
                                                required
                                            />
                                            {
                                                errors?.billingAddress?.firstName && touched?.billingAddress?.firstName && <p style={{ color: "red", fontSize: "12px" }}>{errors?.billingAddress?.firstName}</p>
                                            }
                                        </div>

                                        <div className={styles.profileformGroup}>
                                            <label>Last Name *</label>
                                            <input
                                                type="text"
                                                name="billingAddress.lastName"
                                                value={values.billingAddress.lastName}
                                                onChange={handleChange}
                                                placeholder="Last name"
                                                required
                                            />
                                            {
                                                errors.billingAddress?.lastName && touched.billingAddress?.lastName && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.lastName}</p>
                                            }
                                        </div>
                                    </div>
                                    <div className={styles.profilerow}>
                                        <div className={styles.profileformGroup}>
                                            <label>Phone*</label>
                                            <input
                                                type="tel"
                                                name="billingAddress.phone"
                                                value={values.billingAddress.phone}
                                                onChange={handleChange}
                                                placeholder="Phone"
                                                required
                                            />
                                            {
                                                errors.billingAddress?.phone && touched.billingAddress?.phone && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.phone}</p>
                                            }
                                        </div>

                                        <div className={styles.profileformGroup}>
                                            <label>Email*</label>
                                            <input
                                                type="text"
                                                name="billingAddress.email"
                                                value={values.billingAddress.email}
                                                onChange={handleChange}
                                                placeholder="Email"
                                                required
                                            />
                                            {
                                                errors.billingAddress?.email && touched.billingAddress?.email && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.email}</p>
                                            }
                                        </div>

                                    </div>
                                    <div className={styles.profilerow}>
                                        <div className={styles.profileformGroup}>
                                            <label>Address Line 1 *</label>
                                            <input
                                                type="text"
                                                name="billingAddress.streetAddress"
                                                value={values.billingAddress.streetAddress}
                                                onChange={handleChange}
                                                placeholder="House/Flat No., Building Name"
                                            />
                                            {
                                                errors.billingAddress?.streetAddress && touched.billingAddress?.streetAddress && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.streetAddress}</p>
                                            }
                                        </div>
                                        <div className={styles.profileformGroup}>
                                            <label>Address Line 2</label>
                                            <input
                                                type="text"
                                                name="billingAddress.unit"
                                                value={values.billingAddress.unit}
                                                onChange={handleChange}
                                                placeholder="Street Name, Locality"
                                            />
                                        </div>

                                    </div>
                                    <div className={styles.profilerow}>
                                        <div className={styles.profileformGroup}>
                                            <label>Landmark</label>
                                            <input
                                                type="text"
                                                name="billingAddress.landmark"
                                                value={values.billingAddress?.landmark}
                                                onChange={handleChange}
                                                placeholder="Landmark"
                                            />
                                        </div>
                                        <div className={styles.profileformGroup}>
                                            <label>Country*</label>
                                            <select
                                                name="billingAddress.country"
                                                value={countries.find(c => c.label === values.billingAddress.country)?.value || ""}
                                                onChange={handleBillingCountryChange}
                                                className={styles.selectField}
                                            >
                                                <option value="">Select</option>
                                                {countries.length > 0 ? (
                                                    countries.map((country) => (
                                                        <option key={country.value} value={country.value}>
                                                            {country.label}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option disabled>Loading countries...</option>
                                                )}
                                            </select>
                                            {
                                                errors.billingAddress?.country && touched.billingAddress?.country && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.country}</p>
                                            }
                                        </div>

                                    </div>
                                    <div className={styles.profilerow}>
                                        <div className={styles.profileformGroup}>
                                            <label>State*</label>
                                            <select
                                                name="billingAddress.state"
                                                value={billingStates.find(c => c.label === values.billingAddress.state)?.value || ""}
                                                onChange={handleBillingStateChange}
                                                className={styles.selectField}
                                            >
                                                <option value="">Select State</option>
                                                {billingStates?.map((state) => (
                                                    <option key={state.value} value={state.value}>
                                                        {state.label}
                                                    </option>
                                                ))}
                                            </select>
                                            {
                                                errors.billingAddress?.state && touched.billingAddress?.state && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.state}</p>
                                            }
                                        </div>

                                        <div className={styles.profileformGroup}>
                                            <label>Zip*</label>
                                            <input
                                                type="text"
                                                name="billingAddress.pincode"
                                                value={values.billingAddress.pincode}
                                                onChange={handleChange}
                                                placeholder="Pincode"
                                                required
                                            />
                                            {
                                                errors.billingAddress?.pincode && touched.billingAddress?.pincode && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.pincode}</p>
                                            }
                                        </div>
                                    </div>
                                    <div className={styles.loginFormRow2}>
                                        <div className={styles.profileformGroup}>
                                            <label>City*</label>
                                            <select
                                                name="billingAddress.city"
                                                value={billingCities.find(c => c.label === values.billingAddress.city)?.value || ""}
                                                onChange={handleBillingCityChange}
                                                className={styles.selectField}
                                            >
                                                <option value="">Select City</option>
                                                {billingCities?.map((city) => (
                                                    <option key={city.value} value={city.value}>
                                                        {city.label}
                                                    </option>
                                                ))}
                                            </select>
                                            {
                                                errors.billingAddress?.city && touched.billingAddress?.city && <p style={{ color: "red", fontSize: "12px" }}>{errors.billingAddress?.city}</p>
                                            }
                                        </div>

                                    </div>

                                    <div className={styles.checkboxGroup}>
                                        <input
                                            type="checkbox"
                                            name="saveBillingAddress"
                                            checked={values.saveBillingAddress}
                                            onChange={handleSaveBillingAddress}
                                        />
                                        <label>Save my information for a faster checkout</label>

                                    </div>
                                </>
                            )}
                        </form>
                    </div>

                    <div className={styles.hline} />

                    <div className={styles.chekoutPayment}>
                        <h2>Shipping Address</h2>
                        <span>Select the address that matches your card or payment method.</span>

                        {user?.shippingAddress?.length > 0 ? (
                            <div className={styles.addressSection}>

                                <div className={styles.displayFlex} >
                                    {user?.shippingAddress?.map((item) => (
                                        <div className={styles.address} key={item._id}>
                                            <div className={styles.displayFlex2}>
                                                <input
                                                    type="radio"
                                                    name="shippingAddress"
                                                    checked={values.shippingAddress.streetAddress === item.streetAddress}
                                                    onChange={() => handleSaveShippingAddresses(item)}
                                                />
                                                <div>
                                                    <p className={styles.addressNameText}>{item?.firstName}{" "}{item?.lastName}</p>
                                                    <div>
                                                        <p className={styles.addressText}>{item?.streetAddress} {item?.unit} {item?.city},
                                                            <br />
                                                            {item?.state} {item?.pinCode} {item?.country}</p>
                                                        <p className={styles.addressText}>(+91) {item?.phone}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ cursor: 'pointer' }} onClick={() => handleEditShippingAddress(item)}>
                                                <Edit />
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className={styles.addressDivider} onClick={() => setNewShippingAddress(!newShippingAddress)}>
                                    <button className={styles.addNewAddress}>
                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M24 12.5C24 19.1274 18.6274 24.5 12 24.5C5.37258 24.5 0 19.1274 0 12.5C0 5.87258 5.37258 0.5 12 0.5C18.6274 0.5 24 5.87258 24 12.5ZM12 18.5C11.4477 18.5 11 18.0523 11 17.5V13.5H7C6.44772 13.5 6 13.0523 6 12.5C6 11.9477 6.44772 11.5 7 11.5H11V7.5C11 6.94771 11.4477 6.5 12 6.5C12.5523 6.5 13 6.94771 13 7.5V11.5H17C17.5523 11.5 18 11.9477 18 12.5C18 13.0523 17.5523 13.5 17 13.5H13V17.5C13 18.0523 12.5523 18.5 12 18.5Z" fill="#FE671F" />
                                        </svg>
                                    </button>
                                    <span>Add New Address</span>
                                </div>
                                {newShippingAddress && (
                                    <div style={{ padding: '20px' }}>
                                        <div className={styles.profilerow} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            <div className={styles.profileformGroup}>
                                                <label>First Name *</label>
                                                <input
                                                    type="text"
                                                    name="shippingAddress.firstName"
                                                    value={values.shippingAddress.firstName}
                                                    onChange={handleChange}
                                                    placeholder="First name"
                                                    required
                                                />
                                                {
                                                    errors.shippingAddress?.firstName && touched.shippingAddress?.firstName && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.firstName}</p>
                                                }
                                            </div>

                                            <div className={styles.profileformGroup}>
                                                <label>Last Name *</label>
                                                <input
                                                    type="text"
                                                    name="shippingAddress.lastName"
                                                    value={values.shippingAddress.lastName}
                                                    onChange={handleChange}
                                                    placeholder="Last name"
                                                    required
                                                />
                                                {
                                                    errors.shippingAddress?.lastName && touched.shippingAddress?.lastName && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.lastName}</p>
                                                }
                                            </div>
                                        </div>
                                        <div className={styles.profilerow} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            <div className={styles.profileformGroup}>
                                                <label>Phone *</label>
                                                <input
                                                    type="tel"
                                                    name="shippingAddress.phone"
                                                    value={values.shippingAddress.phone}
                                                    onChange={handleChange}
                                                    placeholder="Phone"
                                                    required
                                                />
                                                {
                                                    errors.shippingAddress?.phone && touched.shippingAddress?.phone && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.phone}</p>
                                                }
                                            </div>

                                            <div className={styles.profileformGroup}>
                                                <label>Email*</label>
                                                <input
                                                    type="text"
                                                    name="shippingAddress.email"
                                                    value={values.shippingAddress.email}
                                                    onChange={handleChange}
                                                    placeholder="Email"
                                                    required
                                                />
                                                {
                                                    errors.shippingAddress?.email && touched.shippingAddress?.email && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.email}</p>
                                                }
                                            </div>

                                        </div>
                                        <div className={styles.profilerow} style={{ paddingTop: 10, paddingBottom: 10 }}>

                                            <div className={styles.profileformGroup}>
                                                <label>Address Line 1 *</label>
                                                <input
                                                    type="text"
                                                    name="shippingAddress.streetAddress"
                                                    value={values.shippingAddress.streetAddress}
                                                    onChange={handleChange}
                                                    placeholder="House/Flat No., Building Name"
                                                />
                                                {
                                                    errors.shippingAddress?.streetAddress && touched.shippingAddress?.streetAddress && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.streetAddress}</p>
                                                }
                                            </div>
                                            <div className={styles.profileformGroup}>
                                                <label>Address Line 2</label>
                                                <input
                                                    type="text"
                                                    name="shippingAddress.unit"
                                                    value={values.shippingAddress.unit}
                                                    onChange={handleChange}
                                                    placeholder="Street Name, Locality"
                                                />
                                            </div>

                                        </div>
                                        <div className={styles.profilerow} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            <div className={styles.profileformGroup}>
                                                <label>Landmark</label>
                                                <input
                                                    type="text"
                                                    name="shippingAddress.landmark"
                                                    value={values.shippingAddress?.landmark}
                                                    onChange={handleChange}
                                                    placeholder="Landmark"
                                                />
                                            </div>
                                            <div className={styles.profileformGroup}>
                                                <label>Country*</label>
                                                <select
                                                    name="shippingAddress.country"
                                                    value={countries.find(c => c.label === values.shippingAddress.country)?.value || ""}
                                                    onChange={handleShippingCountryChange}
                                                    className={styles.selectField}
                                                >
                                                    <option value="">Select Country</option>
                                                    {countries.map((country) => (
                                                        <option key={country.value} value={country.value}>{country.label}</option>
                                                    ))}
                                                </select>
                                                {
                                                    errors.shippingAddress?.country && touched.shippingAddress?.country && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.country}</p>
                                                }
                                            </div>

                                        </div>
                                        <div className={styles.profilerow} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            <div className={styles.profileformGroup}>
                                                <label>State*</label>
                                                <select
                                                    name="shippingAddress.state"
                                                    value={shippingStates.find(c => c.label === values.shippingAddress.state)?.value || ""}
                                                    onChange={handleShippingStateChange}
                                                    className={styles.selectField}
                                                >
                                                    <option value="">Select State</option>
                                                    {shippingStates.map((state) => (
                                                        <option key={state.value} value={state.value}>{state.label}</option>
                                                    ))}
                                                </select>
                                                {
                                                    errors.shippingAddress?.state && touched.shippingAddress?.state && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.state}</p>
                                                }
                                            </div>
                                            <div className={styles.profileformGroup}>
                                                <label>Zip*</label>
                                                <input
                                                    type="text"
                                                    name="shippingAddress.pincode"
                                                    value={values.shippingAddress.pincode}
                                                    onChange={handleChange}
                                                    placeholder="Zip"
                                                    required
                                                />
                                                {
                                                    errors.shippingAddress?.pincode && touched.shippingAddress?.pincode && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.pincode}</p>
                                                }
                                            </div>
                                        </div>

                                        <div className={styles.profilerow} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            <div className={styles.profileformGroup}>
                                                <label>City*</label>
                                                <select
                                                    name="shippingAddress.city"
                                                    value={shippingCities.find(c => c.label === values.shippingAddress.city)?.value || ""}
                                                    onChange={handleShippingCityChange}
                                                    className={styles.selectField}
                                                >
                                                    <option value="">Select City</option>
                                                    {shippingCities.map((city) => (
                                                        <option key={city.value} value={city.value}>{city.label}</option>
                                                    ))}
                                                </select>
                                                {
                                                    errors.shippingAddress?.city && touched.shippingAddress?.city && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.city}</p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className={styles.hline} />
                            </div>
                        ) : (
                            <div className={styles.profileformGroup}
                                style={{ backgroundColor: "#F6F6F6", borderRadius: "4px", marginTop: "20px" }}
                            >
                                <RadioGroup value={selectedShippingAddress} onChange={handleChangeAddress} >
                                    <FormControlLabel
                                        value="Same as Billing address"
                                        control={<Radio sx={{ "&.Mui-checked": { color: "#3C4242", }, }} />}
                                        label={
                                            <Typography sx={{ fontFamily: '"Karla", sans-serif', fontWeight: '700', fontSize: '16px', color: '#3C4242' }}>
                                                Same as Billing address
                                            </Typography>
                                        }
                                        sx={{ paddingLeft: '15px' }}
                                    />
                                    <div className={styles.hline2} ></div>
                                    <FormControlLabel
                                        value="Use a different shipping address"
                                        control={<Radio sx={{ "&.Mui-checked": { color: "#3C4242", }, }} />}
                                        label={
                                            <Typography sx={{ fontFamily: '"Karla", sans-serif', fontWeight: '700', fontSize: '16px', color: '#3C4242' }}>
                                                Use a different shipping address
                                            </Typography>
                                        }
                                        sx={{ paddingLeft: '15px', paddingTop: '10px' }}
                                    />
                                </RadioGroup>
                                {selectedShippingAddress === 'Use a different shipping address' && (
                                    <div style={{ padding: '20px' }}>
                                        <div className={styles.profilerow} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            <div className={styles.profileformGroup}>
                                                <label>First Name *</label>
                                                <input
                                                    type="text"
                                                    name="shippingAddress.firstName"
                                                    value={values.shippingAddress.firstName}
                                                    onChange={handleChange}
                                                    placeholder="First name"
                                                    required
                                                />
                                                {
                                                    errors.shippingAddress?.firstName && touched.shippingAddress?.firstName && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.firstName}</p>
                                                }
                                            </div>

                                            <div className={styles.profileformGroup}>
                                                <label>Last Name *</label>
                                                <input
                                                    type="text"
                                                    name="shippingAddress.lastName"
                                                    value={values.shippingAddress.lastName}
                                                    onChange={handleChange}
                                                    placeholder="Last name"
                                                    required
                                                />
                                                {
                                                    errors.shippingAddress?.lastName && touched.shippingAddress?.lastName && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.lastName}</p>
                                                }
                                            </div>
                                        </div>
                                        <div className={styles.profilerow} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            <div className={styles.profileformGroup}>
                                                <label>Phone *</label>
                                                <input
                                                    type="tel"
                                                    name="shippingAddress.phone"
                                                    value={values.shippingAddress.phone}
                                                    onChange={handleChange}
                                                    placeholder="Phone"
                                                    required
                                                />
                                                {
                                                    errors.shippingAddress?.phone && touched.shippingAddress?.phone && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.phone}</p>
                                                }
                                            </div>

                                            <div className={styles.profileformGroup}>
                                                <label>Email*</label>
                                                <input
                                                    type="text"
                                                    name="shippingAddress.email"
                                                    value={values.shippingAddress.email}
                                                    onChange={handleChange}
                                                    placeholder="Email"
                                                    required
                                                />
                                                {
                                                    errors.shippingAddress?.email && touched.shippingAddress?.email && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.email}</p>
                                                }
                                            </div>

                                        </div>
                                        <div className={styles.profilerow} style={{ paddingTop: 10, paddingBottom: 10 }}>

                                            <div className={styles.profileformGroup}>
                                                <label>Address Line 1 *</label>
                                                <input
                                                    type="text"
                                                    name="shippingAddress.streetAddress"
                                                    value={values.shippingAddress.streetAddress}
                                                    onChange={handleChange}
                                                    placeholder="House/Flat No., Building Name"
                                                />
                                                {
                                                    errors.shippingAddress?.streetAddress && touched.shippingAddress?.streetAddress && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.streetAddress}</p>
                                                }
                                            </div>
                                            <div className={styles.profileformGroup}>
                                                <label>Address Line 2</label>
                                                <input
                                                    type="text"
                                                    name="shippingAddress.unit"
                                                    value={values.shippingAddress.unit}
                                                    onChange={handleChange}
                                                    placeholder="Street Name, Locality"
                                                />
                                            </div>

                                        </div>
                                        <div className={styles.profilerow} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            <div className={styles.profileformGroup}>
                                                <label>Landmark</label>
                                                <input
                                                    type="text"
                                                    name="shippingAddress.landmark"
                                                    value={values.shippingAddress?.landmark}
                                                    onChange={handleChange}
                                                    placeholder="Landmark"
                                                />
                                            </div>
                                            <div className={styles.profileformGroup}>
                                                <label>Country*</label>
                                                <select
                                                    name="shippingAddress.country"
                                                    value={countries.find(c => c.label === values.shippingAddress.country)?.value || ""}
                                                    onChange={handleShippingCountryChange}
                                                    className={styles.selectField}
                                                >
                                                    <option value="">Select Country</option>
                                                    {countries.map((country) => (
                                                        <option key={country.value} value={country.value}>{country.label}</option>
                                                    ))}
                                                </select>
                                                {
                                                    errors.shippingAddress?.country && touched.shippingAddress?.country && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.country}</p>
                                                }
                                            </div>

                                        </div>
                                        <div className={styles.profilerow} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            <div className={styles.profileformGroup}>
                                                <label>State*</label>
                                                <select
                                                    name="shippingAddress.state"
                                                    value={shippingStates.find(c => c.label === values.shippingAddress.state)?.value || ""}
                                                    onChange={handleShippingStateChange}
                                                    className={styles.selectField}
                                                >
                                                    <option value="">Select State</option>
                                                    {shippingStates.map((state) => (
                                                        <option key={state.value} value={state.value}>{state.label}</option>
                                                    ))}
                                                </select>
                                                {
                                                    errors.shippingAddress?.state && touched.shippingAddress?.state && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.state}</p>
                                                }
                                            </div>
                                            <div className={styles.profileformGroup}>
                                                <label>Zip*</label>
                                                <input
                                                    type="text"
                                                    name="shippingAddress.pincode"
                                                    value={values.shippingAddress.pincode}
                                                    onChange={handleChange}
                                                    placeholder="Zip"
                                                    required
                                                />
                                                {
                                                    errors.shippingAddress?.pincode && touched.shippingAddress?.pincode && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.pincode}</p>
                                                }
                                            </div>
                                        </div>

                                        <div className={styles.profilerow} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            <div className={styles.profileformGroup}>
                                                <label>City*</label>
                                                <select
                                                    name="shippingAddress.city"
                                                    value={shippingCities.find(c => c.label === values.shippingAddress.city)?.value || ""}
                                                    onChange={handleShippingCityChange}
                                                    className={styles.selectField}
                                                >
                                                    <option value="">Select City</option>
                                                    {shippingCities.map((city) => (
                                                        <option key={city.value} value={city.value}>{city.label}</option>
                                                    ))}
                                                </select>
                                                {
                                                    errors.shippingAddress?.city && touched.shippingAddress?.city && <p style={{ color: "red", fontSize: "12px" }}>{errors.shippingAddress?.city}</p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* Order Summary */}
                <div className={styles.orderSummary}>
                    <div className={styles.Order}>Order Summary</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        {/* <div className={styles.summaryItem}>
                        <span>Weight</span>
                        <span>{item?.state?.product?.pricing?.totalWeight?.value} grams</span>
                    </div>
                    <div className={styles.summaryItem}>
                        <span>Making Charges</span>
                        <span>{item?.state?.product?.pricing?.makingCharges?.value}%</span>
                    </div>
                    <div className={styles.summaryItem}>
                        <span>Stone Charges</span>
                        <span>Rs {item?.state?.product?.pricing?.stoneCharges?.value}</span>
                    </div>
                    <div className={styles.summaryItem}>
                        <span>GST</span>
                        <span>{item?.state?.product?.pricing?.gst?.value}%</span>
                    </div> */}
                        {priceFromCart !== 0 ? (
                            <div className={styles.summaryItem}>
                                <span className={styles.priceText}>Price</span>
                                <span className={styles.priceText}>₹ {priceFromCart?.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                            </div>
                        ) : (
                            <div className={styles.summaryItem}>
                                <span className={styles.priceText}>{selectedValue === 'Ad Paid' ? "Total Price" : "Price"}</span>
                                <span className={styles.priceText}>₹ {(item?.state?.totalPrice * quantity)?.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                            </div>
                        )}
                        {item?.state?.mrpdiscount === 0 ? (
                            null
                        ) : (
                            <div className={styles.summaryItem}>
                                <span className={styles.priceText}>Discount</span>
                                <span className={styles.priceText}>₹ {(item?.state?.mrpdiscount * quantity)?.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                            </div>
                        )}
                        {/* <div className={styles.summaryItem}>
                        <span className={styles.priceText}>Coupon discount</span>
                        {applyCouponData?.couponCode ? (
                            <span className={styles.coupon} >Coupon Applied</span>
                        ) : <span className={styles.coupon} onClick={() => openCouponPopup()}>Apply coupon</span>}

                    </div> */}
                        <div className={styles.summaryItem} style={{ borderBottom: '1px solid #D1D1D8', paddingBottom: '20px' }}>
                            <span className={styles.priceText}>Shipping</span>
                            <span className={styles.FreeSummary}>Free</span>
                        </div>
                        {grandTotalFromCart !== 0 ? (
                            <div className={styles.summaryTotal} >
                                <span className={styles.priceText}>Total Price</span>
                                <span className={styles.priceText} style={{ fontWeight: '600' }}>₹ {grandTotalFromCart?.toLocaleString("en-IN")}</span>
                            </div>
                        ) : (
                            <div className={styles.summaryTotal} >
                                <span className={styles.priceText}>{selectedValue === 'Ad Paid' ? "Advance Payment" : "Total Price"}</span>
                                <span className={styles.priceText} style={{ fontWeight: '600' }}>₹ {appliedCouponPrice?.toLocaleString("en-IN")}</span>
                            </div>
                        )}
                    </div>
                    <div />
                    <div className={styles.paymentBackground}>
                        <div className={styles.paymentOption} style={{ border: 'none' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <input
                                    type="radio"
                                    id="HDFC"
                                    name="payment.method"
                                    value={values.method}
                                    checked={values.payment.method === "HDFC"}
                                    onChange={() => setFieldValue("payment.method", "HDFC")}
                                />
                                <label htmlFor="HDFC" className={styles.paymentLabel}>Pay with HDFC</label>
                            </div>
                            <img src="/hdfclogo.png" alt="hdfc" />
                        </div>
                        <div className={styles.paymentOption} style={{ border: 'none' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <input
                                    type="radio"
                                    id="RAZORPAY"
                                    name="payment.method"
                                    value={values.method}
                                    checked={values.payment.method === "RAZORPAY"}
                                    onChange={() => setFieldValue("payment.method", "RAZORPAY")}
                                />
                                <label htmlFor="RAZORPAY" className={styles.paymentLabel}>Pay with razorpay</label>
                            </div>
                            <img src="/razorpay-icon.png" alt="razorypay" />
                        </div>
                    </div>

                    <div className={styles.checkboxGroup} style={{ marginTop: 10 }}>
                        <div className={styles.termsStyle}>
                            <input
                                type="checkbox"
                                id="termsCheckbox"
                                name="termsAndCondition"
                                checked={values.termsAndCondition}
                                onChange={(e) => {
                                    setFieldValue('termsAndCondition', e.target.checked);
                                }}
                                style={{ cursor: 'pointer', pointerEvents: 'auto' }}
                            />
                            <label
                                htmlFor="termsCheckbox"
                                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                            >
                                <div
                                    className={styles.checkBoxStyle}
                                    onMouseEnter={() => setHoveredCategory(true)}
                                    onMouseLeave={() => setHoveredCategory(false)}
                                >All T&C
                                    {hoveredCategory && (
                                        <div className={styles.termsAndCondition} dangerouslySetInnerHTML={{ __html: termsAndConditionData?.termsAndCondition }}>

                                        </div>
                                    )}
                                </div>
                            </label>
                        </div>
                    </div>

                    {/* Your form fields here */}

                    {!values.termsAndCondition ? (
                        <>
                            <button className={styles.checkoutDisabledButton} disabled>
                                Proceed to Checkout
                            </button>
                            {errors.termsAndCondition && touched.termsAndCondition && (
                                <p style={{ color: "red", fontSize: "12px" }}>{errors.termsAndCondition}</p>
                            )}
                        </>
                    ) : (
                        <button className={styles.checkoutButton} type="button" onClick={handleCheckoutClick}>
                            Proceed to Checkout
                        </button>
                    )}

                </div>

            </div>
            {/* </form> */}
            <DeleteModal
                closeModal={closeDeleteModal}
                open={isDeleteModalOpen}
                data={datas}
                heading={"Delete Address"}
                handleSubject={deletedData}
                description={'Are you sure you want to delete this shipping address?'}
            />
        </>
    )
}

export default Checkout